import { Domains, TrustpilotLayout } from "@/core/types/types";
import {
  InitialisationConfig,
  LegalArea,
} from "@/core/utils/getInitialisationConfig";
import { getTrustPilotBusinessId } from "@/core/utils/getBrandConfiguration";

interface ISize {
  height: string;
  width: string;
}

const computeTrustpilotLayout = (
  trustpilotBusinessUnitId: string,
  locale: string,
  trustpilotReviewsURL: string,
  trustpilotLinkTitle: string
): TrustpilotLayout => {
  const className: string = "trustpilot-widget";
  const trustpilotHeaderTemplateId: string = "5406e65db0d04a09e042d5fc";
  const trustpilotSidebarTemplateId: string = "53aa8807dec7e10d38f59f32";
  const trustpilotHeaderTheme: string = "dark";
  const trustpilotSidebarTheme: string = "light";
  const trustpilotHeaderSizes: ISize = {
    height: "45px",
    width: "100px",
  };
  const trustpilotSidebarSizes: ISize = {
    height: "150px",
    width: "180px",
  };

  let basicTrustpilotConfig: any = {
    trustpilotBusinessUnitId,
    locale,
    trustpilotReviewsURL,
    trustpilotLinkTitle,
    className,
  };

  return {
    header: {
      ...basicTrustpilotConfig,
      ...trustpilotHeaderSizes,
      trustpilotTemplateId: trustpilotHeaderTemplateId,
      theme: trustpilotHeaderTheme,
    },
    sidebar: {
      ...basicTrustpilotConfig,
      ...trustpilotSidebarSizes,
      trustpilotTemplateId: trustpilotSidebarTemplateId,
      theme: trustpilotSidebarTheme,
    },
  };
};

const getTrustPilotConfiguration = (
  initialisationConfig: InitialisationConfig
): TrustpilotLayout | null => {
  const {
    locale: currentLocale,
    domain,
    brandId: brand,
    legalArea,
  } = initialisationConfig;

  if (legalArea === LegalArea.MIE) return null;

  const locale: string = currentLocale?.replace("_", "-");
  const reviewsUrlPrefix: string = domain === Domains.DE ? "de" : "www";
  const reviewsUrlReference: string = `${brand}.${
    domain === Domains.UK ? "co." + domain : domain
  }`;
  const trustpilotReviewsURL: string = `https://${reviewsUrlPrefix}.trustpilot.com/review/${reviewsUrlReference}`;
  // TODO: Move texts to translations
  const trustpilotGeneralLinkTitle: string =
    "What do other customers say? (Open in new window)";
  const trustpilotGermanLinkTitle: string =
    "Was sagen andere Kunden? (In neuem Fenster öffnen)";
  const trustpilotLinkTitle: string =
    domain === Domains.DE
      ? trustpilotGermanLinkTitle
      : trustpilotGeneralLinkTitle;
  const businessId: string =
    legalArea === LegalArea.APR
      ? getTrustPilotBusinessId(brand, legalArea, domain)
      : getTrustPilotBusinessId(brand, legalArea, Domains.DEFAULT);

  return computeTrustpilotLayout(
    businessId,
    locale,
    trustpilotReviewsURL,
    trustpilotLinkTitle
  );
};

export default getTrustPilotConfiguration;
